<template>
  <div id="app">
    <header class="site-header">
      <div class="container-fluid">
        <nav class="site-nav">
          <router-link class="site-nav-link"
                       to="/">
            <site-brand />
          </router-link>
          <router-link class="site-nav-link hamburger hamburger--elastic"
                       v-if="$route.name !== 'home'"
                       to="/">
            <span class="hamburger-box">
              <span class="hamburger-inner"></span>
            </span>
          </router-link>
        </nav>
      </div>
    </header>
    <main class="site-content">
      <div class="global-loader"
           v-resize-text="{ratio:.5, delay: 0}"
           v-if="loadCount">
        <site-loader />
      </div>
      <template v-else>
        <vue-page-transition>
          <router-view />
        </vue-page-transition>
      </template>
    </main>
  </div>
</template>

<script type="text/javascript">
import { mapState } from 'vuex'
export default {
  name: 'app',
  computed: {
    ...mapState({
      loadCount: state => state.loadCount
    })
  },
  beforeMount () {
    this.$store.dispatch('fetchData')
  }
}
</script>

<style lang="scss">
  @import './assets/scss/default.scss';
</style>
